export const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-US", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
    });

    return formattedDate;
};


// export const getWeekStartEnd = (month,week,year) => {
//     const firstDayOfMonth = new Date(year, month - 1, 1);
//     const firstMonday = new Date(firstDayOfMonth);
//
//     // Find the first Monday of the month
//     while (firstMonday.getDay() !== 1) {
//         firstMonday.setDate(firstMonday.getDate() + 1);
//     }
//
//     // Calculate the start of the requested week
//     const startDate = new Date(firstMonday);
//     startDate.setDate(firstMonday.getDate() + (week - 1) * 7);
//
//     // Calculate the end of the requested week (Sunday)
//     const endDate = new Date(startDate);
//     endDate.setDate(startDate.getDate() + 6);
//
//
//     let dateFormated = `${startDate.toISOString().split('T')[0]} - ${endDate.toISOString().split('T')[0]}`
//
//     return dateFormated;
// }

// export const getWeekStartEnd = (month, week, year) => {
//     const firstDayOfMonth = new Date(year, month - 1, 1);
//     const firstMonday = new Date(firstDayOfMonth);
//
//     // Find the first Monday of the month
//     while (firstMonday.getDay() !== 1) {
//         firstMonday.setDate(firstMonday.getDate() + 1);
//     }
//
//     // Calculate the start of the requested week
//     const startDate = new Date(firstMonday);
//     startDate.setDate(firstMonday.getDate() + (week - 1) * 7);
//
//     // Calculate the end of the requested week (Sunday)
//     const endDate = new Date(startDate);
//     endDate.setDate(startDate.getDate() + 6);
//
//     // Format dates in MM/DD/YYYY
//     const formatDate = (date) => date.toLocaleDateString('en-US');
//
//     return `${formatDate(startDate)} - ${formatDate(endDate)}`;
// };

export const getWeekStartEnd = (month, week, year) => {
    const firstDayOfMonth = new Date(year, month - 1, 1);

    // Find the first Monday that belongs to this month
    // (not the Monday before the month starts)
    let firstMondayInMonth = new Date(firstDayOfMonth);

    // If the month doesn't start on Monday, find the first Monday in the month
    if (firstDayOfMonth.getDay() !== 1) { // 1 is Monday
        // Days to add to get to Monday (if day is Sunday (0), add 1, if Tuesday (2) add 6, etc.)
        const daysUntilMonday = (8 - firstDayOfMonth.getDay()) % 7;
        firstMondayInMonth.setDate(firstDayOfMonth.getDate() + daysUntilMonday);
    }

    // Calculate the start of the requested week
    const startDate = new Date(firstMondayInMonth);
    startDate.setDate(firstMondayInMonth.getDate() + (week - 1) * 7);

    // Calculate the end of the requested week (always Sunday)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    // Format dates as MM/DD/YYYY
    const formatDate = (date) => {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    };

    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};

export const getQuarterlyMonthlyTargets = (monthlyData, quarterNumber) => {
    if (!monthlyData || typeof monthlyData !== "object") {
        return []; // Return empty array if input is invalid
    }

    // Define which months belong to which quarter
    const quarterMonthsMap = {
        1: [1, 2, 3],  // Q1 -> Jan, Feb, Mar
        2: [4, 5, 6],  // Q2 -> Apr, May, Jun
        3: [7, 8, 9],  // Q3 -> Jul, Aug, Sep
        4: [10, 11, 12] // Q4 -> Oct, Nov, Dec
    };

    // Get the months for the requested quarter
    const monthsInQuarter = quarterMonthsMap[quarterNumber] || [];

    // Format data to ensure each month appears in the structure
    const formattedData = monthsInQuarter.map(month => ({
        month, // Month number
        monthlyTargets: monthlyData[month.toString()]?.monthlyTargets || [] // Default to empty array if no data
    }));

    return formattedData;
};

// Helper function to calculate the number of weeks in a month
export const getWeeksInMonth = (month, year) => {
    // Get the first day of the month
    const firstDay = new Date(year, month - 1, 1);

    // Find the first Monday that belongs to this month
    let firstMondayInMonth = new Date(firstDay);

    // If the month doesn't start on Monday, find the first Monday in the month
    if (firstDay.getDay() !== 1) { // 1 is Monday
        // Days to add to get to Monday (if day is Sunday (0), add 1, if Tuesday (2) add 6, etc.)
        const daysUntilMonday = (8 - firstDay.getDay()) % 7;
        firstMondayInMonth.setDate(firstDay.getDate() + daysUntilMonday);
    }

    // Get the last day of the month
    const lastDay = new Date(year, month, 0);

    // Calculate the number of days between first Monday in month and last day
    const daysDiff = Math.floor((lastDay - firstMondayInMonth) / (24 * 60 * 60 * 1000)) + 1;

    // Calculate weeks (7 days per week, rounded up)
    return Math.ceil(daysDiff / 7);
};

export const getMonthName = (monthNumber) => {
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    return monthNames[monthNumber - 1] || "Invalid Month"; // Adjust index and handle errors
};

// Helper function to get the week start date in MM/DD/YYYY format
export const getWeekStartDate = (month, week, year) => {
    const firstDayOfMonth = new Date(year, month - 1, 1);

    // Find the first Monday that belongs to this month
    let firstMondayInMonth = new Date(firstDayOfMonth);

    // If the month doesn't start on Monday, find the first Monday in the month
    if (firstDayOfMonth.getDay() !== 1) { // 1 is Monday
        const daysUntilMonday = (8 - firstDayOfMonth.getDay()) % 7;
        firstMondayInMonth.setDate(firstDayOfMonth.getDate() + daysUntilMonday);
    }

    // Calculate the start of the requested week
    const startDate = new Date(firstMondayInMonth);
    startDate.setDate(firstMondayInMonth.getDate() + (week - 1) * 7);

    // Format date as MM/DD/YYYY with leading zeros
    const month2Digits = String(startDate.getMonth() + 1).padStart(2, '0');
    const day2Digits = String(startDate.getDate()).padStart(2, '0');
    const year4Digits = startDate.getFullYear();

    return `${month2Digits}/${day2Digits}/${year4Digits}`;
};

